/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatedApiResponse } from '../../models/created-api-response';
import { CreateSettingCommand } from '../../models/create-setting-command';

export interface CreateSettingAsync$Plain$Params {
      body?: CreateSettingCommand
}

export function createSettingAsync$Plain(http: HttpClient, rootUrl: string, params?: CreateSettingAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatedApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createSettingAsync$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatedApiResponse>;
    })
  );
}

createSettingAsync$Plain.PATH = '/api/settings';
